import { SVGAttributes } from 'react'

export function KeyReturnIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M9.49976 4.43759V6.43747C9.49976 6.57007 9.44708 6.69724 9.35332 6.791C9.25955 6.88476 9.13238 6.93744 8.99978 6.93744H4.20693L4.85377 7.58365C4.90022 7.6301 4.93707 7.68525 4.96221 7.74594C4.98735 7.80663 5.00029 7.87168 5.00029 7.93738C5.00029 8.00307 4.98735 8.06812 4.96221 8.12881C4.93707 8.1895 4.90022 8.24465 4.85377 8.2911C4.80731 8.33756 4.75217 8.3744 4.69147 8.39954C4.63078 8.42468 4.56573 8.43762 4.50004 8.43762C4.43434 8.43762 4.36929 8.42468 4.3086 8.39954C4.24791 8.3744 4.19276 8.33756 4.14631 8.2911L2.64639 6.7912C2.59991 6.74476 2.56303 6.68962 2.53787 6.62893C2.51271 6.56823 2.49976 6.50317 2.49976 6.43747C2.49976 6.37176 2.51271 6.3067 2.53787 6.24601C2.56303 6.18531 2.59991 6.13017 2.64639 6.08374L4.14631 4.58383C4.24012 4.49002 4.36736 4.43731 4.50004 4.43731C4.63271 4.43731 4.75995 4.49002 4.85377 4.58383C4.94758 4.67765 5.00029 4.80489 5.00029 4.93756C5.00029 5.07023 4.94758 5.19747 4.85377 5.29129L4.20693 5.9375H8.49981V4.43759C8.49981 4.30499 8.55249 4.17782 8.64625 4.08406C8.74001 3.9903 8.86718 3.93762 8.99978 3.93762C9.13238 3.93762 9.25955 3.9903 9.35332 4.08406C9.44708 4.17782 9.49976 4.30499 9.49976 4.43759Z'
        fill='currentColor'
      />
    </svg>
  )
}
